import { Navigate } from 'react-router-dom';

import { ERROR } from '../../../constants/routes';
import { EXECUTION } from '../../../constants/execution-modes';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

export const ExecutionRoute = ({
    appLoaded,
    children,
    executionMode,
    homeworkLoaded,
    notLoggedModalShowed,
    httpStatus,
    paused,
    started,
    finished,
    terminateHomework,
}) => {
    const UNPROCESSABLE_UPDATE_ERROR = 422;
    useEffect(() => {
        if (!finished && httpStatus.httpCode === UNPROCESSABLE_UPDATE_ERROR) {
            terminateHomework();
        }
    }, [finished, httpStatus.httpCode, terminateHomework]);

    if (appLoaded.pending || !homeworkLoaded || notLoggedModalShowed) {
        return children;
    }

    if (!started || paused || executionMode !== EXECUTION) {
        return (
            <Navigate
                to={{
                    pathname: ERROR,
                }}
            />
        );
    }
    return children;
};

ExecutionRoute.propTypes = {
    appLoaded: PropTypes.object,
    children: PropTypes.node,
    executionMode: PropTypes.string,
    homeworkLoaded: PropTypes.bool,
    httpStatus: PropTypes.object,
    notLoggedModalShowed: PropTypes.bool,
    paused: PropTypes.bool,
    terminateHomework: PropTypes.func,
    started: PropTypes.bool,
    finished: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        appLoaded: state.appLoading.appLoaded,
        authStatus: state.auth.status,
        executionMode: state.application.executionMode,
        homeworkLoaded: state.homework.status.loaded,
        homeworkStatus: state.homework.status,
        httpStatus: state.status.httpStatus,
        notLoggedModalShowed: state.modal.notLoggedModalShowed,
        paused: state.status.paused,
        started: state.status.started,
        finished: state.status.finished,
    };
};

export default connect(mapStateToProps)(ExecutionRoute);
